// extracted by mini-css-extract-plugin
export default {"tooltip":"wo-z","sharingV2":"xo-z","sharingIconsV2":"yo-z","links":"zo-z","link":"Ao-z","facebookV2":"Bo-z","twitterV2":"Co-z","pinterestV2":"Do-z"};